<template>
  <div class="media-container">
    <div class="media-content" :style="'min-height:'+height+'px;'">
      <el-tabs tab-position="top" v-model="classIndex" @tab-click="handleClick">
        <el-tab-pane v-for="(row) in classList" :label="row.name" :name="'tab'+row.fid"/>
      </el-tabs>
      <media-item v-for="(item,index) in dataList" :options="item" :uid="uid" @delItem="delItem"
                  @refreshList="getPersonalArticle" style="padding: 15px 25px;"/>
      <el-empty description="没有内容" v-if="dataList.length == 0"></el-empty>
      <!-- 分页 -->
      <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage" style="padding:0px 0px 15px 20px;"/>
    </div>
    <div class="introduce" ref="introduce">
      <div class="title">我的简介</div>
      <div class="small-menu">
        <div class="label-fade"><i class="iconfont icon-anquan default-color"/>认证：{{ info.identity_type_name }}</div>
        <div class="label-fade"><i class="iconfont icon-jianjie default-color"/>
          <el-tooltip :content="info.introduce" placement="left-start" effect="light">
            <p class="introduce-text">简介：{{ info.introduce }}</p>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page from "@/components/page/pages";
import mediaItem from "@/components/AuthorContent/mediaItem";
import {microArticleLists, homepageComponentRest} from '@/api/interfaceApi'

export default {
  name: "index",
  components: {page, mediaItem},
  data() {
    return {
      classList: [],
      classIndex: 'first',
      dataList: [],
      hasMore: false,//是否有更多文本
      textHeight: 0,//文本高度
      maxH: 85,
      authenticationInfo: '',
      FlowList: {},
      page: 1,
      type: '1',
      uid: 0,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      height:'auto',
      cid:0,
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    /*去掉所有的html标记*/
    delHtmlTag(str) {
      return str.replace(/<[^>]+>/g, "");//去掉所有的html标记
    },
    //获取文章视频
    getPersonalArticle() {
      this.dataList = [];
      microArticleLists({
        bid: parseInt(this.$route.query.bid),
        page: this.tablePage.currentPage,
        type: parseInt(this.type),
        uid: this.cid,
      }).then(res => {
        if (res.code == 200) {
          this.tablePage.total = parseInt(res.total);
          if (res.content !== undefined && res.total > 0) {
            if (res.content != '' && res.content != null && res.content != undefined) {
              for (let rows of res.content) {
                if (rows.photo) {
                  if (rows.photo.indexOf('。') > -1)
                    rows.photo = rows.photo.split('。')
                }
                if (rows.content != '' && rows.content != null && rows.content != undefined)
                  rows.content = this.delHtmlTag(rows.content.replace(/&nbsp;/ig, " "))
              }
            }
            this.dataList = res.content;
          }
        }
      })
    },
    //切换顶部数据
    handleClick(tab, event) {
      this.type = (tab.name).split('tab')[1]
      this.tablePage.currentPage = 1;
      this.getPersonalArticle();
    },
    delItem(options) {
      const loading = this.$loading({
        lock: true, text: '删除中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
      });
      /* deleteArticle({id: options.id, request: 'form'}).then(res => {
         loading.close();
         if (res.code == 200) {
           this.$message.success("删除成功");
           this.getPersonalArticle();
         }
       }).catch(err => {
         loading.close();
       })*/
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getPersonalArticle();
    },
    /*获取动态分类*/
    gethomepageComponentRest() {
      homepageComponentRest({
        bid: parseInt(this.$route.query.bid),
        uid: this.cid!=undefined && this.cid!=0 ? this.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          this.classList = res.content;
          this.classIndex = 'tab' + this.classList[0].fid
        }
      })
    }
  },
  mounted() {
    this.getPersonalArticle();
    let that=this;
    setTimeout(function () {
      that.height=that.$refs.introduce.clientHeight;
    }, 500);

  },
  beforeMount() {
    this.cid=sessionStorage.getItem('loginData')!='' &&  sessionStorage.getItem('loginData')!=null && sessionStorage.getItem('loginData')!=undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.gethomepageComponentRest();
  }
}
</script>
<style scoped>
.media-container >>> .media-content .el-tabs__item {
  font-size: 20px;
  font-family: 'SourceHanSansCN';
  font-weight: 500;
  height: 45px;
}
.media-container >>> .media-content .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #F1F1F1;
}
.media-container >>> .media-content .el-tabs__header {
  padding: 20px 0px 0px 20px;
  position: relative;
  margin: 0 0 20px;
}
.media-container >>> .media-content .el-tabs__active-bar {
  height: 2px;
  background-color: #FD2F38;
}
.media-container >>> .media-content .el-tabs__item:hover {
  color: #0067DD;
  cursor: pointer;
}
.media-container >>> .media-content  .el-tabs__item.is-active {
   color: #333333;
 }
</style>
<style scoped lang="scss">
.media-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  .media-content {
    margin: 20px 0px 0px;
    background: white;
    border-radius: 10px;
    width: 75%;

    .class-list {
      font-family: "微软雅黑";
      display: flex;
      align-items: center;
      padding: 20px 0px 0px 20px;
      font-size: 19px;
      color: #333;

      .class-item {
        margin-right: 30px;
        cursor: pointer;
      }
    }
  }

  .introduce {
    background: white;
    border-radius: 12px;
    margin-top: 20px;
    margin-left: 20px;
    width: 25%;
    height: fit-content;

    .title {
      padding: 20px 0px 10px 20px;
      border-bottom: 1px solid #E4ECF5;
    }

    .small-menu {
      padding: 10px 20px;
      line-height: 30px;
      font-size: 14px;
      color: #333333;

      .gray-span {
        color: #666;
      }

      .label-fade {
        color: #333333;
        display: flex;
        align-items: baseline;
        .introduce-text{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 10;
          overflow: hidden;
        }
      }

      .default-color {
        color: #333333;
        padding-right: 5px;
      }
    }
  }

  .isActive ::after {
    display: block;
    position: absolute;
    width: 18px;
    height: 3px;
    background-color: #1637FF;
    bottom: 0;
    left: 20%;
  }

  .isActive {
    color: #1637FF;
    border-color: #1637FF;
  }
}
</style>
<style>
.el-tooltip__popper {
  border-radius: 4px;
  padding: 10px;
  max-width: 480px;
  min-width: 10px;
  word-wrap: break-word;
  font-size: 14px;
  line-height: 30px;
}
</style>